<template>
	<div class="body">
		<div class="body-container" v-if="baseData">

			<div class="title-ctr">{{title}}</div>

			<div class="step-ctr">
				<div class="step-route" @click="clickRule(ruleData)">{{ruleData.title}}</div>
			</div>


			<div class="title-ch">{{baseData.title}}</div>

			<div class="factor-ctr">
				<label class="factor-name">{{baseData.industryData.title}}</label>

				<div class="factor-input">{{baseData.industryData.value}}</div>
			</div>

			<div class="factor-ctr">
				<label class="factor-name">{{baseData.graduData.title}}</label>

				<el-input class="factor-input" v-model="graduRate" @input="graduRateChange" type="number"
					:step="baseData.graduData.step"></el-input>

				<label class="factor-note">调整区间：{{baseData.graduData.min}}-{{baseData.graduData.max}}</label>
			</div>

			<div class="factor-ctr">
				<label class="factor-name">{{baseData.flowData.title}}</label>

				<el-input class="factor-input" v-model="flowRate" @input="flowRateChange" type="number"
					:step="baseData.flowData.step"></el-input>

				<label class="factor-note">调整区间：{{baseData.flowData.min}}-{{baseData.flowData.max}}</label>
			</div>

			<div class="factor-ctr">
				<label class="factor-name">{{baseData.limitData.title}}</label>

				<el-input class="factor-input" v-model="limitRate" @input="limitRateChange" type="number"
					:step="baseData.limitData.step"></el-input>

				<label class="factor-note">调整区间：{{baseData.limitData.min}}-{{baseData.limitData.max}}</label>
			</div>

			<div class="title-ch">{{weightData.title}}</div>

			<el-table :data="weightData.list" border stripe>
				<el-table-column label="行业名称" align="center" prop="name" />
				<el-table-column label="行业权重" align="center" prop="weight" />
			</el-table>
		</div>


		<div class="action-ctr">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">下一步</el-button>
		</div>

		<el-dialog title="原理介绍" :visible.sync="showIntroDialog" append-to-body v-if="showIntroDialog" align="center">

			<div class="rich-ctr">
				<div class="rich-value" v-html="introDialog.value"></div>
			</div>


			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseIntroDialog()">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog :title="dataTitle" :visible.sync="showDataDialog" append-to-body v-if="showDataDialog"
			align="center">

			<div class="data-ctr">
				<el-input v-model="dataValue" placeholder="请输入数值" class="data-input" />
			</div>


			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickConfirmData()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getTargetFitConfig,
		updateFitBaseConfig,
		updateFitIndustryConfig
	} from "@/api/service"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				params: {
					page: 1,
					pageSize: 20
				},
				title: '',
				baseData: null,
				weightData: null,
				showIntroDialog: false,
				introDialog: null,
				variableType: {
					File: 2,
					Rich: 3
				},
				showDataDialog: false,
				dataTitle: '',
				dataValue: '',
				graduRate: 0,
				flowRate: 0,
				limitRate: 0,
				ruleData: null,
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.params['id'] = this.$route.query.id;
				this.requestData();
			},

			buildParams() {
				this.params['rowId'] = this.rowId;
				this.params['field'] = this.field;
				this.params['type'] = 'enroll';
				this.params['value'] = this.dataValue;
				this.params['year'] = this.year;
				return this.params;
			},

			requestData() {
				getTargetFitConfig(this.buildParams()).then(res => {
					let realData = res.data;
					this.title = realData.title;
					this.baseData = realData.baseData;
					this.weightData = realData.weightData;
					this.graduRate = this.baseData.graduData.value;
					this.flowRate = this.baseData.flowData.value;
					this.limitRate = this.baseData.limitData.value;
					this.ruleData = realData.ruleData;
				});
			},

			clickNext() {
				let path = '/fit_industry?id=' + this.params['id']
				this.$router.push(path);
			},

			clickRule(route) {
				if (route.type == this.variableType.File) {
					let path = route.path;
					window.open(path, '_blank')
				} else if (route.type == this.variableType.Rich) {
					this.showIntroDialog = true;
					this.introDialog = route;
				}
			},

			clickCloseIntroDialog() {
				this.showIntroDialog = false;
			},


			clickChangeData(id, year, field, name, value) {
				let title = year + '年' + name;

				title += '数据修改';

				this.rowId = id;
				this.year = year;
				this.field = field;
				this.dataTitle = title;
				this.dataValue = value;
				this.showDataDialog = true;
			},

			clickConfirmData() {
				updateFitBaseConfig(this.buildParams()).then(res => {
					this.requestData();
					this.showDataDialog = false;
				})
			},

			getNumValue(row, year) {
				// 安全访问，逐级判断
				if (row && row.map && row.map[year] && row.map[year]['num'] !== undefined) {
					return row.map[year]['num'];
				}
				return 0; // 默认值
			},
			
			graduRateChange(num) {
				// 最小值限制
				if (num < this.baseData.graduData.min) {
					num = this.baseData.graduData.min;
				}
			
				// 最大值限制
				if (num > this.baseData.graduData.max) {
					num = this.baseData.graduData.max;
				}
			
				// 保留小数位数（可选）
				this.graduRate = num
			
				this.onFactorChange('graduRate', num);
			},
			
			flowRateChange(num) {
				// 最小值限制
				if (num < this.baseData.flowData.min) {
					num = this.baseData.flowData.min;
				}
			
				// 最大值限制
				if (num > this.baseData.flowData.max) {
					num = this.baseData.flowData.max;
				}
			
				// 保留小数位数（可选）
				this.flowRate = num
			
				this.onFactorChange('flowRate', num);
			},
			
			
			limitRateChange(num) {
				// 最小值限制
				if (num < this.baseData.limitData.min) {
					num = this.baseData.limitData.min;
				}
			
				// 最大值限制
				if (num > this.baseData.limitData.max) {
					num = this.baseData.limitData.max;
				}
			
				// 保留小数位数（可选）
				this.limitRate = num
			
				this.onFactorChange('lowerLimit', num);
			},
			
			onFactorChange(type, value){
				updateFitBaseConfig({
					'id': this.params['id'],
					'type': type,
					'value': value
				}).then(res => {
					this.requestData();
				})
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "fit_config.scss";
</style>